import callAPI from 'api'

import { SearchAccountPayload, SearchAccountResponse } from './types/search'

export const searchAccount = async (payload: SearchAccountPayload) => {
  const response = await callAPI<SearchAccountResponse, SearchAccountPayload>('crm_search_account', [payload], {
    requireAuthorization: true,
  })
  return response
}
